<template>
  <!-- About Us Header with Background Image -->
  <section class="about-header text-center mt-0" style="background: url('/images/insidegym8.jpg') no-repeat center center; background-size: cover; padding: 50px 0; color: #fff;">
    <h1 class="display-4 font-weight-bold">BLOG</h1>
  </section>

  <div class="blog-container">
    <div class="row">
      <!-- Blog Post -->
      <div class="col-md-4 mb-4" v-for="(post, index) in posts" :key="index">
        <div class="blog-card">
          <img :src="post.image" class="img-fluid blog-card-image" alt="Blog Post Image">
          <div class="blog-card-body">
            <h4 class="blog-card-title">{{ post.title }}</h4>
            <p class="blog-card-summary">{{ post.summary }}</p>
            <router-link :to="'/blog/' + post.id" class="btn btn-primary">Read More</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlogPage",
  data() {
    return {
      posts: [
        {
          id: 1,
          title: "Transform Your Body: 5 Essential Fitness Tips",
          summary: "Discover top fitness tips that will help you achieve your fitness goals and transform your body.",
          image: "/images/indoorcycling.jpg"
        },
        {
          id: 2,
          title: "Why Functional Training is the Key to Longevity",
          summary: "Learn why functional training can enhance your overall health, strength, and flexibility.",
          image: "/images/functionaltraining.jpg"
        },
        {
          id: 3,
          title: "The Importance of Rest Days in Your Fitness Journey",
          summary: "Understand why rest and recovery are just as crucial as training in achieving your fitness goals.",
          image: "/images/bodybuilding.jpg"
        },
      ],
    };
  },
};
</script>

<style scoped>
.about-header h1 {
  font-size: 3rem;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}

.blog-container {
  margin-top: 60px;
  background-color: #f7f7f7;
  padding: 60px 20px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.blog-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.blog-card img {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  height: 220px; /* Set height of images */
  object-fit: cover;
  width: 100%; /* Ensure the image spans the full width */
}

.blog-card-body {
  padding: 25px;
  flex-grow: 1; /* Ensure that the body takes up remaining space */
}

.blog-card-title {
  font-size: 1.8rem;
  color: #f2b705;
  font-weight: 700;
  margin-bottom: 15px;
}

.blog-card-summary {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 20px;
}

.btn-primary {
  background-color: #f2b705;
  border: none;
  padding: 12px 25px;
  border-radius: 6px;
  font-size: 1.1rem;
  text-decoration: none;
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.btn-primary:hover {
  background-color: #f2b705;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.blog-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.blog-card-body {
  padding: 25px;
  flex-grow: 1; /* Ensure that the body takes up remaining space */
}

/* Mobile Responsive */
@media (max-width: 767px) {
  .blog-container {
    padding: 40px 10px;
  }

  .blog-title {
    font-size: 2.2rem;
  }

  .blog-card img {
    height: 180px;
  }

  .blog-card-body {
    padding: 20px;
  }

  .blog-card-title {
    font-size: 1.4rem;
  }

  .blog-card-summary {
    font-size: 1rem;
  }
}
</style>
